import { Topbar } from "components/ui/shared/Topbar"
import { Button } from "components/ui/controls/Button"
import { useContext, useState } from "react"
import { SearchBar } from "components/ui/inputs/SearchBar";
import styled from "styled-components";
import { NotesGrid } from "components/features/notes/NotesGrid";
import { Tab, TabsGroup } from "components/ui/controls/Tabs";
import { NotesContext } from "providers/NotesProvider";
import { ProjectsContext } from "providers/ProjectsProvider";
import { CreateNewFolderModal } from "components/features/notes/CreateNewFolderModal";
import { EditFolderNameModal } from "components/features/notes/EditFolderNameModal";
import { CreateNewNoteModal } from "components/features/notes/CreateNewNoteModal";
import { EditNoteNameModal } from "components/features/notes/EditNoteNameModal";
import { useErrors } from "providers/ErrorsProvider";
import { MaterialIcon } from "components/ui/shared/MaterialIcon";

export const Notes = () => {
    const [selectedFolderUuid, setSelectedFolderUuid] = useState(null);
    const [selectedFolderName, setSelectedFolderName] = useState(null);
    const { notes, notebooks, notesHandler, notebooksHandler } = useContext(NotesContext);
    const {setError, unsetError} = useErrors();

    const [notesFilter, setNotesFilter] = useState({search: ''});
    const [notesSource, setNotesSource] = useState("projects");
    
    const { projects } = useContext(ProjectsContext);

    const [creatingNewFolder, setCreatingNewFolder] = useState(false);
    const [editingNotebookName, setEditingNotebookName] = useState(null);
    const [creatingNewNote, setCreatingNewNote] = useState(null);
    const [editingNoteName, setEditingNoteName] = useState(null);    

    const updateNotebook = ({notebookUuid, notebookName, notebookStatus}) => {

        if(notebookName && notebookName.length < 5)
        {
            setError("NOTES_FOLDERNAME_TOO_SHORT");
            unsetError("NOTES_FOLDERNAME_TOO_LONG");
        }
        else if(notebookName && notebookName.length > 45)
        {
            setError("NOTES_FOLDERNAME_TOO_LONG");
            unsetError("NOTES_FOLDERNAME_TOO_SHORT");
        }
        else
        {
            unsetError("NOTES_FOLDERNAME_TOO_SHORT");
            unsetError("NOTES_FOLDERNAME_TOO_LONG");
            notebooksHandler({
                notebookUuid,
                action: "UPDATE NOTEBOOK",
                changes:
                {
                    notebookName, 
                    notebookStatus
                }
            }).then(res => {
                if(res?.status) setError(res?.reason);
            });

            setEditingNotebookName(null);
        }
    }

    const createNotebook = ({notebookName}) => {
        if(notebookName && notebookName.length < 5)
        {
            setError("NOTES_FOLDERNAME_TOO_SHORT");
            unsetError("NOTES_FOLDERNAME_TOO_LONG");
        }
        else if(notebookName && notebookName.length > 45)
        {
            setError("NOTES_FOLDERNAME_TOO_LONG");
            unsetError("NOTES_FOLDERNAME_TOO_SHORT");
        }
        else if(notebookName.length > 3 && notebookName.length <= 45)
        {
            unsetError("NOTES_FOLDERNAME_TOO_SHORT");
            unsetError("NOTES_FOLDERNAME_TOO_LONG");

            const newNotebookUuid = crypto.randomUUID();
            notebooksHandler({
                notebookUuid: newNotebookUuid,
                action: "CREATE NOTEBOOK",
                changes:
                {
                    notebookName,
                    notebookUuid: newNotebookUuid,
                    notebookStatus: 'Active'
                }
            }).then(res => {
                if(res?.status) setError(res?.reason);
            });

            setCreatingNewFolder(null);
        }
        
    }

    const createNote = ({noteTitle}) => {
        if(!selectedFolderUuid) return;
        if(noteTitle && noteTitle.length < 5)
        {
            setError("NOTES_NOTETITLE_TOO_SHORT");
            unsetError("NOTES_NOTETITLE_TOO_LONG");
        }
        else if(noteTitle && noteTitle.length > 45)
        {
            setError("NOTES_NOTETITLE_TOO_LONG");
            unsetError("NOTES_NOTETITLE_TOO_SHORT");
        }
        else if(noteTitle ? noteTitle.length > 3 && noteTitle.length <= 100 : true)
        {
            unsetError("NOTES_NOTETITLE_TOO_SHORT");
            unsetError("NOTES_NOTETITLE_TOO_LONG");
            const newNoteUuid = crypto.randomUUID();
            notesHandler({
                noteUuid: newNoteUuid,
                action: "CREATE NOTE",
                changes:
                {
                    noteUuid: newNoteUuid,
                    noteTitle: noteTitle,
                    noteTitleVersion: 1,
                    noteContentSummary: '',
                    noteParentUuid: selectedFolderUuid,
                    noteStatus: 'Active',
                    noteTimestamp: (new Date()).toISOString(),
                }
            }).then(res => {
                if(res?.status) setError(res?.reason);
            });

            setCreatingNewNote(null);
        }
        else return;
    }

    const updateNote = async ({noteUuid, noteTitle, noteStatus}) => {
        if(!noteUuid) setEditingNoteName(null);
        if(noteTitle && noteTitle.length < 5)
        {
            setError("NOTES_NOTETITLE_TOO_SHORT");
            unsetError("NOTES_NOTETITLE_TOO_LONG");
        }
        else if(noteTitle && noteTitle.length > 45)
        {
            setError("NOTES_NOTETITLE_TOO_LONG");
            unsetError("NOTES_NOTETITLE_TOO_SHORT");
        }
        else if(noteTitle ? noteTitle.length > 3 && noteTitle.length <= 100 : true)
        {
            unsetError("NOTES_NOTETITLE_TOO_SHORT");
            unsetError("NOTES_NOTETITLE_TOO_LONG");
            await notesHandler({
                noteUuid,
                action: "UPDATE NOTE",
                changes:
                {
                    noteUuid,
                    noteTitle,
                    noteStatus
                }
            }).then(res => {
                if(res?.status) setError(res?.reason);
            });
            setEditingNoteName(null);
        }
        else return null;
    }
    
    const filterNotes = () => {
        let nts = notes.map(note => {
            
            if(note.noteParentUuid !== selectedFolderUuid) return null;

            let searchFilter = true;

            if(!note.noteTitle.toLowerCase().includes(notesFilter.search.toLowerCase()) && !note.noteContentSummary?.toLowerCase().includes(notesFilter.search.toLowerCase())) searchFilter = false;

            if(searchFilter) return note;
            else return null;
        })

        return nts;
    }

    return (
        <>
            <Topbar breacrumb={['Notater']}>
                <Button
                    type='primary'
                    text="Ny notat"
                    prefix={<MaterialIcon name='add' weight={300}/>}
                    onClick={() => {
                        if(!selectedFolderUuid) return;
                        setCreatingNewNote(true);
                    }}
                />
            </Topbar>
            <StyledNotesContainer>
                <div className="notesHeader">
                    <span className="title">
                        Notater
                    </span>
                </div>
                <div className="notesContent">
                    <div className="notesNav">
                        <div className="navHeader">
                            <TabsGroup
                                paddingLeft='md'
                                paddingRight='md'
                                onChange={(e) => setNotesSource(e)}
                            >
                                <Tab
                                    name="Prosjektmapper"
                                    value="projects"
                                    isSelected={notesSource === 'projects'}
                                />
                                 <Tab
                                    name="Andre mapper"
                                    value="notebooks"
                                    isSelected={notesSource === 'notebooks'}
                                />
                            </TabsGroup>
                        </div>
                        <div className="navContent">
                            {
                                notesSource === 'projects' ? 
                                projects.map(prj => prj.projectNotes && prj.projectNotes.enabled ?
                                    <FolderLink
                                        key={prj.projectUuid}
                                        root={prj}
                                        type='project'
                                        isSelected={selectedFolderUuid === prj.projectUuid}
                                        onClick={() => {
                                            setSelectedFolderUuid(prj.projectUuid);
                                            setSelectedFolderName(prj.projectName);
                                        }}
                                    /> : null)
                                :
                                notebooks.map(nbs => <FolderLink
                                                        key={nbs.notebookUuid}
                                                        root={nbs}
                                                        type='notebook'
                                                        isSelected={selectedFolderUuid === nbs.notebookUuid}
                                                        onClick={() => {
                                                            setSelectedFolderUuid(nbs.notebookUuid);
                                                            setSelectedFolderName(nbs.notebookName);
                                                        }}
                                                        onEdit={() => setEditingNotebookName({notebookUuid: nbs.notebookUuid, notebookName: nbs.notebookName})}
                                                        onArchive={() => updateNotebook({notebookUuid: nbs.notebookUuid, notebookStatus: "Archived"})}
                                                    />)
                            }
                        </div>
                        {
                            notesSource === 'notebooks' ?
                            <div className="navFooter">
                                <StyledButton
                                    type="secondary"
                                    text="Ny mappe"
                                    onClick={() => setCreatingNewFolder(true)}
                                />
                            </div>
                            : null
                        }
                    </div>
                    <div className="notesView">
                        {
                            selectedFolderUuid ? 
                                <>
                                    <div className="notesViewHeader">
                                        <div className="notesViewFolderTitle">
                                            <MaterialIcon name='folder' weight={300}/> {selectedFolderName}
                                        </div>
                                        <SearchBar
                                            placeholder='Søk i notater...'
                                            onChange={(e) => setNotesFilter(prev => ({...prev, search: e.target.value}))}
                                        />
                                    </div>
                                    <NotesGrid
                                        createNote={() => {setCreatingNewNote(true)}}
                                        editNote={(noteUuid, noteTitle) => {setEditingNoteName({noteUuid, noteTitle})}}
                                        archiveNote={(noteUuid) => {updateNote({noteUuid, noteStatus: 'Archived'})}}
                                        notes={filterNotes()}
                                    />
                                </>
                            
                             : null
                            
                        }
                    </div>
                </div>
            </StyledNotesContainer>
            {
                creatingNewFolder ?
                <CreateNewFolderModal
                    onSubmit={(name) => createNotebook({notebookName: name})}
                    onDiscard={() => setCreatingNewFolder(false)}
                /> : null
            }
            {
                editingNotebookName ?
                <EditFolderNameModal
                    onSubmit={(name) => updateNotebook({notebookName: name, notebookUuid: editingNotebookName.notebookUuid})}
                    onDiscard={() => setEditingNotebookName(null)}
                    value={editingNotebookName.notebookName}
                /> : null
            }
            {
                creatingNewNote ?
                <CreateNewNoteModal
                    onSubmit={(name) => createNote({noteTitle: name})}
                    onDiscard={() => setCreatingNewNote(null)}
                /> : null
            }
            {
                editingNoteName ? 
                <EditNoteNameModal
                    onSubmit={(noteTitle) => updateNote({noteUuid: editingNoteName.noteUuid, noteTitle})}
                    onDiscard={() => setEditingNoteName(null)}
                    value={editingNoteName.noteTitle}
                /> : null
            }
            
        </>
    )
}

const StyledNotesContainer = styled.div`
    padding-left: ${({theme}) => theme.spacing.xl};
    padding-right: ${({theme}) => theme.spacing.xl};
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    div.notesHeader 
    {
        margin-bottom: ${({theme}) => theme.spacing.lg};

        span.title
        {   
            font-size: ${({theme}) => theme.fontSize.xxl};
            font-weight: 500;
            display: block;
        }
    }

    div.notesContent
    {
        display: flex;
        height: 100%;
        width: 100%;
        gap: ${({theme}) => theme.spacing.lg};
        overflow: hidden;

        div.notesNav
        {
            border: 1px solid ${({theme}) => theme.colors.neutralPrimaryBorder};
            border-radius: ${({theme}) => theme.cornerRadius.md};
            width: 350px;
            display: flex;
            flex-direction: column;

            div.navHeader
            {
                background: ${({theme}) => theme.colors.neutralSecondaryBackground};
                padding-top: ${({theme}) => theme.spacing.md};
            }

            div.navContent
            {
                padding: ${({theme}) => theme.spacing.lg} ${({theme}) => theme.spacing.md};
                display: flex;
                flex-direction: column;
                gap: ${({theme}) => theme.spacing.sm};
                flex: 1;

            }

            div.navFooter
            {
                padding: ${({theme}) => theme.spacing.md};
            }
        }

        div.notesView
        {
            flex: 1;
            overflow: auto;
            display: flex;
            flex-direction: column;
            gap: ${({theme}) => theme.spacing.lg};

            div.notesViewHeader
            {
                display: flex;
                justify-content: space-between;
                align-items: center;

                div.notesViewFolderTitle
                {
                    display: flex;
                    align-items: center;
                    gap: ${({theme}) => theme.spacing.md};
                    font-weight: 500;
                    font-size: ${({theme}) => theme.fontSize.xl};

                    svg
                    {
                        height: ${({theme}) => theme.fontSize.xxl};
                        width: ${({theme}) => theme.fontSize.xxl};
                    }
                }
            }
        }
    }
`

const StyledButton = styled(Button)`
    width: 100%;
`

const FolderLink = ({root, type, isSelected, onClick, onEdit, onArchive}) => {

    return (
        <StyledFolderLink
            onClick={onClick}
            className={isSelected ? 'isSelected' : null}
        >
            <MaterialIcon className='folderIcon' name='folder' weight={300}/>
            <div
                className="folderName"
                
            >
                {
                    type === 'project' ? root.projectName :
                    type === 'notebook' ? root.notebookName :
                    null
                }
            </div>
            {
                type === 'notebook' ?
                <div className="options">
                    <div className="moreIcon">
                        <MaterialIcon
                            name='more_vert'
                            weight={300}
                            size='sm'
                            color={({theme}) => theme.colors.mutedForeground}
                        />
                    </div>
                    <div className="moreOptions">
                        <MaterialIcon
                            name="inventory_2"
                            weight={300}
                            size='sm'
                            color={({theme}) => theme.colors.errorForeground}
                            onClick={(e) => {
                                e.stopPropagation();
                                onArchive?.();
                            }}
                        />
                        <MaterialIcon
                            name='edit'
                            weight={300}
                            size='sm'
                            color={({theme}) => theme.colors.mutedForeground}
                            onClick={(e) => {
                                e.stopPropagation();
                                onEdit?.()
                            }}
                        />
                    </div>
                </div>
                : null
            }
            
            
        </StyledFolderLink>
    )
}

const StyledFolderLink = styled.div`
    padding: ${({theme}) => theme.spacing.sm};
    height: 24px;
    display: flex;
    align-items: center;
    gap: ${({theme}) => theme.spacing.md};
    border-radius: ${({theme}) => theme.cornerRadius.md};
    cursor: pointer;
    border: 1px solid transparent;
    transition-duration: 220ms;
    padding: ${({theme}) => theme.spacing.xs} ${({theme}) => theme.spacing.md};
    font-size: ${ ({theme}) => theme.fontSize.md};

    .folderIcon
    {
        color: ${({theme}) => theme.colors.mutedForeground};
    }

    div.folderName
    {
        flex: 1;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    div.options
    {
        display: flex;
        align-items: center;
        color: ${({theme}) => theme.colors.mutedForeground};

        div.moreIcon
        {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 20px;
            transition-duration: 110ms;
        }

        div.moreOptions
        {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: ${({theme}) => theme.spacing.sm};
            overflow: hidden;
            width: 0;
            transition-duration: 110ms;
            
            .archiveIcon
            {
                color: ${({theme}) => theme.colors.errorForeground};
                stroke-width: 2px;
                width: ${({theme}) => theme.iconSize.sm};
                height: ${({theme}) => theme.iconSize.sm};
                cursor: pointer;
            }
        }

        &:hover
        {
            div.moreIcon
            {
                width: 0;
                opacity: 0;
            }
        
            div.moreOptions
            {
                width: 47px;
            }
        }


    }

    &.isSelected
    {
        border: 1px solid rgba(${ ({theme}) => theme.colors.neutralPrimaryForegroundRGB}, 0.05);
        background: ${ ({theme}) => theme.colors.neutralPrimaryBorder};

        font-weight: 600;
        color: ${ ({theme}) => theme.colors.neutralPrimaryForeground};

        .folderIcon
        {
            color: ${({theme}) => theme.colors.neutralPrimaryForeground};
        }
    }
`